import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindAll } from '@bibliocommons/utils-react';
import ManifestationListItemContainer from '../ManifestationListItem/ManifestationListItemContainer';
import './ManifestationList.scss';

export class ManifestationList extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  renderListings() {
    const { manifestations, reciprocalRank } = this.props;
    const singleItem = manifestations.count() === 1;
    return manifestations.map(item => (
      <ManifestationListItemContainer
        item={item}
        key={item.get('id')}
        drawerOpen={singleItem}
        reciprocalRank={reciprocalRank}
      />
    ));
  }

  render() {
    return <div className="cp-manifestation-list">{this.renderListings()}</div>;
  }
}

ManifestationList.propTypes = {
  manifestations: ImmutablePropTypes.list,
  reciprocalRank: PropTypes.number
};

ManifestationList.defaultProps = {
  manifestations: []
};

export default ManifestationList;
